<template>
  <div class="!pt-0">
    <div class="flex flex-col max-h-screen pt-16 pb-2.5 min-h-screen space-y-2.5">
      <div class="flex items-stretch justify-between mt-2.5">
        <div class="element-island">
          <h1 class="text-3xl font-bold text-gray-900">
            Purchase Orders
          </h1>

          <p class="mt-2 text-sm text-gray-600">
            Manage purchase orders for this project
          </p>
        </div>

        <div
          v-if="project?.unarchived"
          class="element-island flex items-center"
        >
          <button
            type="button"
            class="btn btn--secondary-blue space-x-2 flex items-center"
            @click="showAddModal = true"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
  <path fill-rule="evenodd" d="M12 3.75a.75.75 0 01.75.75v6.75h6.75a.75.75 0 010 1.5h-6.75v6.75a.75.75 0 01-1.5 0v-6.75H4.5a.75.75 0 010-1.5h6.75V4.5a.75.75 0 01.75-.75z" clip-rule="evenodd" />
</svg>

            <span>Add purchase order</span>
          </button>
        </div>
      </div>

      <div class="element-island overflow-y-auto flex flex-col flex-1 p-4">
        <PurchaseOrdersTable
          ref="purchaseOrdersTableRef"
          @open-details="openDetails"
        />
      </div>
    </div>

    <AddPurchaseOrderModal
      v-if="showAddModal"
      :project-id="props.projectId"
      @close="showAddModal = false"
      @created="onCreated"
    />

    <PurchaseOrderShowModal
      v-if="showDetailModal && selectedPurchaseOrderId !== undefined"
      :purchase-order-id="selectedPurchaseOrderId"
      :project-id="props.projectId"
      @close="closeDetails"
      @updated="purchaseOrdersTableRef?.reload()"
    />
  </div>
</template>

<script setup lang="ts">
import AddPurchaseOrderModal from '@/components/HeadContract/PurchaseOrders/AddPurchaseOrderModal.vue';
import PurchaseOrderShowModal from '@/components/HeadContract/PurchaseOrders/PurchaseOrderShowModal.vue';
import PurchaseOrdersTable from '@/components/HeadContract/PurchaseOrders/PurchaseOrdersTable.vue';
import useBoqLockRedirect from '@/composables/useBoqLockRedirect';
import PurchaseOrder from '@/models/PurchaseOrder';
import { useProjectsStore } from '@/store/projects';
import { computed, ref, useTemplateRef, watch } from 'vue';
import { useRouter } from 'vue-router';

const props = defineProps<{
  projectId: string;
  purchaseOrderId?: string;
}>();

const projectsStore = useProjectsStore();
const project = computed(() => projectsStore.project);
const purchaseOrdersTableRef = useTemplateRef('purchaseOrdersTableRef');
const selectedPurchaseOrderId = ref<number | undefined>();
const showDetailModal = ref(false);
const showAddModal = ref(false);
const router = useRouter();

const openDetails = (purchaseOrder: PurchaseOrder) => {
  router.replace({
    name: 'PurchaseOrdersSchedule',
    params: { projectId: props.projectId, purchaseOrderId: purchaseOrder.id.toString() },
  });

  selectedPurchaseOrderId.value = purchaseOrder.id;
  showDetailModal.value = true;
};

const closeDetails = () => {
  router.replace({ name: 'PurchaseOrdersSchedule', params: { projectId: props.projectId } });
  showDetailModal.value = false;
  selectedPurchaseOrderId.value = undefined;
};

const onCreated = () => {
  purchaseOrdersTableRef.value?.reload();
};

watch(() => props.purchaseOrderId, (newValue) => {
  if(newValue) {
    selectedPurchaseOrderId.value = parseInt(newValue);
    showDetailModal.value = true;
  }
}, { immediate: true });

useBoqLockRedirect();
</script>
